<template>
  <div class="component">
    <div class="tab_focus" >
      <div class="focus-title">
        <span style="margin: 4px 6px 0 0;"><span class="kdfont kdfont-zhinengbiaoqian"></span></span>
        <div class="title-content">简历亮点</div>
      </div>
      <div class="focus-content-box" v-if=prominent>
        <div
            v-for="item in componentData"
            class="focus-content"
        >
          <div class="tag-prominent">
            <portrait-labels :labelList=convert(item.prominentName)></portrait-labels>
          </div>
          <div class="tag-content">{{ item.prominentDesc }}</div>
        </div>
      </div>
      <div class="noData" v-if="!prominent">暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabProminent",
  props: {
    componentData: [Object, Array]
  },
  watch:{
    componentData:{
      handler(val) {
        this.prominent = val != null && val.length > 0 ? true : false
      },
      immediate: true
    },
  },
  data() {
    return {
      prominent:false
    }
  },
  mounted() {
    console.log(this.componentData)
  },
  methods: {
    convert(prominentName) {
      return new Array(prominentName)
    }
  },
}
</script>

<style lang="less">
.tab_focus {
  display: flex;
  flex-direction: column;

  .focus-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;

    .title-content {
      font-size: 16px;
      color: #212121;
      font-weight: 600;
    }
  }

  .focus-content-box{
    display: flex;
    flex-direction: column;
    margin-bottom: -12px;
  }
  .focus-content {
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    margin-bottom: 16px;

    .tag-prominent {
      display: flex;
      align-items: center;
      .component_label{
        background: rgba(255,255,255,0.00);
        border: 1px solid #1BA854;
        border-radius: 10px;
        font-size: 12px;
        color: #1BA854;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
        margin-bottom: 5px;
      }
    }

    .tag-content {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: left;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
    }
  }
}
.noData{
  color: #999;
  padding: 0 0 4px 22px;
}
</style>

